<template>
  <b-modal title=""
           size="lg"
           v-model="modalObservacionesDoctores"
           hide-footer
           hide-header
  >
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div fluid>
      <b-row class="ml-3 mb-2">
        <h3><em class="tabla_diente_svg icon-boton sm"></em></h3>
        <p style="color: var(--color-dentalia); font-size: 20px; font-weight: bold; padding-top: 5px; padding-left: 8px;">
          Información sobre cambios y nuevos tratamientos</p>
      </b-row>
      <b-row class="mr-1 ml-1">
        <b-col class="text-left">
          <p class="pb-0 mb-1" style="font-size: 14px;">Doctor(es) que solicitaron</p>
          <b-card style="border-color: var(--color-dentalia-v2); border-radius: 15px;">
            <b-form-input
                v-model="listaDoctoresFiltro.nombre"
                placeholder="Ingresa un nombre"
                type="text"
                v-on:keypress="esLetra($event)"
                @keyup.prevent="buscarDoctoresEnFiltros($event)"
            ></b-form-input>

            <b-dropdown-divider></b-dropdown-divider>

            <validation-provider
                :name="'validacioncausa' + options.check"
                :rules="{ required: true }"
                v-slot="causaSlot"
            >
              <b-form-checkbox-group stacked style="overflow: auto;  max-height: 200px" v-model="selected"
                                     @input="marcarDoctor()">
                <template v-for="(d,i) in options">
                  <b-form-checkbox :key="d+i" v-if="d.visible == true" :value="d.value">
                    <div class="row ml-1">
                      <p style="font-size: 14px;">{{ d.nombre }} </p>
                      <p style="font-size: 12px; color: #8a8a8a;">({{ d.especialidad }})</p>
                    </div>
                  </b-form-checkbox>
                </template>
              </b-form-checkbox-group>
              <validacion
                  :texto="causaSlot.errors[0] ? causaSlot.errors[0] : ''"
              ></validacion>
            </validation-provider>
          </b-card>
        </b-col>
        <b-col class="text-left">
          Observaciones
          <validation-provider
              :name="'validacioncausa' + datosDoctoresObservaciones.observaciones"
              :rules="{ required: true }"
              v-slot="observacionesSlot"
          >
            <b-form-textarea
                id="textarea"
                v-model="datosDoctoresObservaciones.observaciones"
                placeholder="Escriba sus observaciones"
                max-rows="10"
                style="border-radius: 10px; height: 50%;"
            ></b-form-textarea>
            <validacion
                :texto="observacionesSlot.errors[0] ? observacionesSlot.errors[0] : ''"
            ></validacion>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col style="text-align: right;">
          <b-button @click="continuar()" pill variant="primary" :disabled="datosDoctoresObservaciones.ids.length == 0 || datosDoctoresObservaciones.observaciones == ''">
            Continuar
          </b-button>
        </b-col>
        <b-col style="text-align: left;">
          <b-button @click="cerrarModal()" pill>Cancelar</b-button>
        </b-col>
      </b-row>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: "InformacionCambiosEdicionPtiV5",
  props: {
    tratamientosPrioridadCambios: Array,
    tratamientosHallazgosCambios: Array,
    listPadecimientosAgregar: Array,
    opcionesEstatus: Array
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      modalObservacionesDoctores: false,
      listaDoctoresFiltro: [],
      options: [],
      selected: [],
      datosDoctoresObservaciones: {
        ids: [],
        observaciones: "",
      },
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.traerDoctores();
  },
  methods: {
    traerDoctores(){
      this.loader = true;
      const params = {
        idClinica:this.$localStorageService.getIdClinica()
      }
      this.$http.post(this.$api + "colaboradores/obtenerEmpleadosEspecialidad", params
      ).then((response) => {
        if (response.status === 200) {
          this.listaDoctores = response.data.data.map((it) => {
            return {
              id: it.idEmpleado,
              nombre:  it.nombreEmpleado + " (" + this.obtenerEspecialidadesDoctor(it) + ")",
              nombreDoctor: it.nombreEmpleado,
              especialidad: this.obtenerEspecialidadesDoctor(it),
              visible: false,
              check: false,
            };
          }).filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
          this.listaDoctoresFiltro = this.listaDoctores;
        }
      })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.llenarOpciones();
            this.loader = false;
          });
    },
    obtenerEspecialidadesDoctor(doctor) {
      if ( doctor.especialidades.length > 0) {
        var esp = "";
        doctor.especialidades.forEach(f => {
          esp += f + ", "
        })
        return esp;
      } else {
        return "-";
      }
    },
    llenarOpciones(){
      this.listaDoctoresFiltro.forEach(df => {
        this.options.push({text: df.nombre, value: df.id, numeroEmpleado: df.numeroEmpleado, nombre: df.nombreDoctor, especialidad: df.especialidad, visible: true})
      });
    },



    esLetra(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    buscarDoctoresEnFiltros() {
      this.options.forEach(o => {
        if(o.nombre.toUpperCase().includes(this.listaDoctoresFiltro.nombre.toUpperCase())){
          o.visible = true;
        }else{
          o.visible = false;
        }
      });
    },
    marcarDoctor(){
      this.datosDoctoresObservaciones.ids = [];
      this.selected.forEach(s => {
        this.datosDoctoresObservaciones.ids.push(s);
      });
      this.listaDoctoresFiltro.forEach(ldf => {
        if(this.datosDoctoresObservaciones.ids.includes(ldf.id)){
          ldf.check = true;
        }else{
          ldf.check = false;
        }
      });
    },
    continuar(){
      this.abrirModal(2);
    },
    cerrarModal(){
      this.modalObservacionesDoctores = false;
    },
    abrirModalDoctor() {
      this.modalObservacionesDoctores = true;
    },
    abrirModal(noModal) {
      // * Modal 1 es cuando sale de MODO EDICION CUANDO TIENE CAMBIOS
      if (noModal === 1) {
        let tituloAlerta = '<span class="mt-4" style="font-weight:600; font-size: 20px; color: var(--color-gris)">¿Está seguro de cerrar el modo edición?</span></br></br>'
        let parrafo = '<span >Si continúa se perderán los cambios,</br>' +
            '¿desea continuar?</span>'
        this.$swal.fire({
          width: '550px',
          icon: 'warning',
          html: tituloAlerta + parrafo,
          showCloseButton: false,
          showCancelButton: true,
          confirmButtonText: 'Sí',
          confirmButtonColor: '#eeba6d',
          cancelButtonText: 'No',
          cancelButtonColor: '#595959',
          customClass: {
            confirmButton: 'mr-5 rounded-pill',
            cancelButton: 'ml-5 rounded-pill'
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.modoEdicion = false;
            this.$refs.ptiActual.salirModoEdicion();
            this.obtenerFaseSeleccionada(this.opcionPtiSeleccionadaSubtitulo);
            this.datosTablaNuevosTratamientos = [];
          }
        })
      }

      // * Modal 2 es cuando GUARDA LOS CAMBIOS
      if (noModal === 2) {
        let tituloAlerta = '<span class="mt-4" style="font-weight:600; font-size: 20px; color: var(--color-gris)">Se realizarán los siguientes cambios ¿Desea </br> continuar?</span></br></br>'

        /**
         * EMPIEZA LA CONSTRUCCION DE LA TABLA
         */

        let tabla =
            '<div class="contenedorTablaSinColor p-2"><table style="width: 100%; font-size: 14px;">' +
            '  <tr style="border-bottom: 1px solid #ccc;">' +
            '    <th>Tratamiento</th>' +
            '    <th>Origen del <br>tratamiento</th>' +
            '    <th>Movimiento</th>' +
            '    <th>Se enviará a UP</th>' +
            '  </tr>';

        this.listPadecimientosAgregar.forEach(t => t.listaTratamientos.forEach(tx => {

          let colorLetra = '';
          if (tx.estatus === 4 || tx.estatus === 1) { //Nuevo
            colorLetra = '#2a9317';
          }

          tabla += `<tr>
                      <td><div style="padding: 5px;">${tx.nombreTratamiento}</td>
                      <td style="color: ${colorLetra}">${tx.estatus === 4 ? 'Nuevo':'PTI'}</td>
                      <td style="color: ${colorLetra}"></td>
                      <td style="color: ${colorLetra}">${tx.estatus === 4 ? 'Sí':''}</td>
                    </tr>`;
        }));

        this.tratamientosPrioridadCambios.forEach(tx => {

          let colorLetra = '';
          let estatusTexto = this.opcionesEstatus.find(op => {
            if (tx.estatus !== 0) {
              if (tx.estatus === 1) {
                return op.idEstatusPtiTratamiento === 7;
              } else if (tx.estatus === 2) {
                return op.idEstatusPtiTratamiento === 5;
              } else if (tx.estatus === 3) {
                return op.idEstatusPtiTratamiento === 8;
              }
            }
            /*else if (tx.cambioTratamientoActivo) {
              return op.idEstatusPtiTratamiento === 8;
            }*/
          }).descripcion;

          if (tx.estatus === 2) { //Eliminado
            colorLetra = '#df0404';
          } else if (tx.estatus === 3 || tx.cambioTratamientoActivo) { //Cambio de Tratamiento
            colorLetra = '#d46718';
          } else if (tx.estatus === 1) { //Nuevo
            colorLetra = '#2a9317'
          }

          tabla += `<tr>
                      <td><div style="padding: 5px;">${tx.tratamiento}</td>
                      <td style="color: ${colorLetra}">PTI</td>
                      <td style="color: ${colorLetra}">${estatusTexto}</td>
                      <td style="color: #2a9317">${tx.cambioTratamientoActivo || tx.estatus === 1 ? 'Sí':''}</td>
                    </tr>`;
        })

        this.tratamientosHallazgosCambios.forEach(tx => {

          let colorLetra = '';
          let estatusTexto = this.opcionesEstatus.find(op => {
            if (tx.estatus !== 0) {
              if (tx.estatus === 1) {
                return op.idEstatusPtiTratamiento === 7;
              } else if (tx.estatus === 2) {
                return op.idEstatusPtiTratamiento === 5;
              }

            }

          }).descripcion;

          if (tx.estatus === 2) { //Eliminado
            colorLetra = '#df0404';
          } else if (tx.estatus === 1) { //Nuevo
            colorLetra = '#2a9317'
          }

          tabla += `<tr>
                      <td><div style="padding: 5px;">${tx.tratamiento}</td>
                      <td style="color: ${colorLetra}">PTI</td>
                      <td style="color: ${colorLetra}">${estatusTexto}</td>
                      <td style="color: ${colorLetra}">${tx.estatus === 1 ? 'Sí':''}</td>
                    </tr>`;
        })

        tabla += '</table></div>'; //AQUI FINALIZA LA CONSTRUCCION DE LA TABLA
        this.$swal.fire({
          width: '750px',
          icon: 'warning',
          html: tituloAlerta + tabla,
          showCloseButton: false,
          showCancelButton: true,
          confirmButtonText: 'Sí, continuar',
          confirmButtonColor: '#eeba6d',
          cancelButtonText: 'No, cancelar',
          cancelButtonColor: '#FFF',
          customClass: {
            confirmButton: 'mr-5 rounded-pill',
            cancelButton: 'ml-5 rounded-pill text-secondary border border-secondary'
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit('verificarCorteCaja', this.datosDoctoresObservaciones);
            this.datosDoctoresObservaciones = {
              ids: [],
              observaciones: ""
            }
            this.selected = [];
            this.modalObservacionesDoctores = false;
            this.listaDoctoresFiltro.nombre = '';
            this.buscarDoctoresEnFiltros();
          }
        })
      }

      // * Modal 3 cuando NO HAY NUEVOS TX PROGRAMADOS
      if (noModal === 3) {
        this.$swal.fire({
          icon: 'success',
          html: '<span class="mt-4" style="font-weight:600; font-size: 19px; color: var(--color-gris)">Edición de tratamientos guardada exitosamente</span>',
          showCloseButton: false,
          confirmButtonText: 'cerrar',
          confirmButtonColor: '#595959',
          customClass: {
            confirmButton: 'rounded-pill',
          },
          preConfirm: () => {
            let index = this.listaTxModificados.findIndex(i => i.idEstatus === 2);
            if(index >= 0) {
              this.$router.push({
                name: "resumenClinicoSeguimientoVisible",
                params: {
                  idPti: this.idPti,
                  idSolicitud: this.idSolicitud,
                  opcion: this.opcionAceptadaHistorial,
                },
              });
            }else{
              this.modoEdicion = false;
              this.$refs.ptiActual.salirModoEdicion();
              this.obtenerPtiActual();
            }
          }
        })
      }

      // * Modal 3 cuando SI HAY NUEVOS TX PROGRAMADOS
      if (noModal === 4) {
        let tituloAlerta = '<span class="mt-4" style="font-weight:600; font-size: 19px; color: var(--color-gris)">Edición de tratamientos guardada exitosamente</span></br></br>'
        let parrafo = '<span >Ahora se presentarán los tratamientos que se enviaron a la Unidad de Presentación</span>'

        this.$swal.fire({
          width: '620px',
          icon: 'success',
          html: tituloAlerta + parrafo,
          showCloseButton: false,
          confirmButtonText: 'cerrar',
          confirmButtonColor: '#595959',
          customClass: {
            confirmButton: 'rounded-pill',
          },
          preConfirm: () => {
            this.$router.push({
              name: "resumenClinicoSeguimientoVisible",
              params: {
                idPti: this.idPti,
                idSolicitud: this.idSolicitud,
                opcion: this.opcionAceptadaHistorial,
              },
            });
          }
        })
      }
      // * Modal 4 cuando HAY NUEVOS TX PROGRAMADOS
    },
  }
}
</script>

<style scoped>

</style>